import { useFeatureFlags } from '@hooks/LaunchDarkly/useFeatureFlags';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { getPriceDisclosureStartingLabel, getPriceDisclosureTaxesAndFeesLabel, getPriceDisclosureValidLabel } from 'lib/utilities/CruiseCard';
import { useContext } from 'react';
import { CruiseCardPriceDisclosureBase, CruiseCardPriceDisclosureLabel } from './CruiseCardPriceDisclosure.styles';
import { CruiseCardPriceDisclosureProps } from './CruiseCardPriceDisclosure.types';

function CruiseCardPriceDisclosure({ sailing, packageId }: CruiseCardPriceDisclosureProps) {
	const { globalization, locale }: any = useContext(CruiseSearchContext);
	const { enableBundledTaxesAndFees } = useFeatureFlags();
	const { itineraryCardsDictionary } = globalization?.dictionaries || {};
	const { labelStartingPriceIn, labelPriceDisclaimerPrepender, labelTaxesAndFeesStatement, labelTaxesAndFeesPriceBundle } = itineraryCardsDictionary;

	const bundlePriceLabel = sailing.lowestPrice?.hasTaxesAndFeesIncluded && enableBundledTaxesAndFees ? labelTaxesAndFeesPriceBundle : '';

	return (
		<CruiseCardPriceDisclosureBase data-testid={`cruise-price-disclosure-label-${packageId}`}>
			<CruiseCardPriceDisclosureLabel>
				{`${getPriceDisclosureStartingLabel(labelStartingPriceIn, locale)}, ${getPriceDisclosureValidLabel(labelPriceDisclaimerPrepender, sailing.startDate, locale.language)} ${bundlePriceLabel}`}
			</CruiseCardPriceDisclosureLabel>
			{!!sailing.lowestPrice.taxesAndFees && !sailing.lowestPrice.hasTaxesAndFeesIncluded && (
				<CruiseCardPriceDisclosureLabel>
					{getPriceDisclosureTaxesAndFeesLabel(labelTaxesAndFeesStatement, locale, sailing.lowestPrice.taxesAndFees)}
				</CruiseCardPriceDisclosureLabel>
			)}
		</CruiseCardPriceDisclosureBase>
	);
}

export default CruiseCardPriceDisclosure;
